export default __webpack_public_path__ + "static/media/Nioicon.08e5ad1d.woff";